// شارة «شات الفريق» (0128): كم رسالةً لم أقرأها في الجروب والخاصّ.
//
// **من النبضة** (27/09/2026): مع `/pulse` كل عشر ثوانٍ، والصوت حين تصل رسالةٌ جديدة وأنا خارج شاشة الفريق
// (داخلها تتولّاه الشاشة نفسها). وبلا مزوّد نبضة (الاختبارات القديمة) يُسأل `/team/summary` كل 15 ثانية كما كان.
import { useEffect, useRef, useState } from 'react';
import { get, type TeamSummary } from '../lib/api.ts';
import { usePulse } from '../lib/pulse.tsx';
import { playTeamChatSound } from '../notifications/notificationSound.ts';
import { systemNotify } from '../notifications/systemNotify.ts';

const POLL_MS = 15_000;

export function useTeamSummary(enabled: boolean, onTeamScreen: boolean): number {
  const pulse = usePulse();
  const live = pulse !== null && pulse.healthy;   // نبضةٌ فاشلة = بلا نبضة (مراجعة 27/09/2026)
  const [badge, setBadge] = useState(0);
  const last = useRef<TeamSummary | null>(null);
  const onScreen = useRef(onTeamScreen);
  onScreen.current = onTeamScreen;

  const apply = (s: TeamSummary) => {
    if (last.current && !onScreen.current && s.lastSeq > last.current.lastSeq && s.unread > 0) {
      playTeamChatSound();   // الأعلى (01/10/2026)
      systemNotify('💬 رسالة جديدة في شات الفريق', `عندك ${s.unread} رسالة لم تُقرأ`, 'team-chat');   // قرار المالك 01/10/2026
    }
    last.current = s;
    setBadge(s.unread);
  };

  const team = pulse?.data?.team ?? null;
  useEffect(() => {
    if (!live) return;
    if (!enabled || !team) { setBadge(0); last.current = null; return; }
    apply(team);
    /* eslint-disable-next-line react-hooks/exhaustive-deps */
  }, [live, enabled, team]);

  useEffect(() => {
    if (live) return;
    if (!enabled) { setBadge(0); last.current = null; return; }
    let alive = true;
    const tick = async () => {
      try { const s = await get<TeamSummary>('/team/summary'); if (alive) apply(s); }
      catch { /* خطأ مؤقت: يبقى العدد كما هو — صفرٌ كاذب كان يمسح إشعار الشات من شريط الموبايل */ }
    };
    void tick();
    const id = setInterval(() => { void tick(); }, POLL_MS);
    return () => { alive = false; clearInterval(id); };
    /* eslint-disable-next-line react-hooks/exhaustive-deps */
  }, [enabled, live]);

  return badge;
}
